var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"e-supporters"},[_c('p',[_vm._v(_vm._s(_vm.$t('system.supportedBy')))]),_c('ul',[_c('li',[_c('IconOTWO',{staticClass:"OTWO"})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }